import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createResaleItem, resaleItemsQueryKeys } from '@api/resaleItems';
import type { CreateResaleItemResponse } from '@api/resaleItems';

interface UseCreateResaleItemOptions {
  onSuccess?: (response: CreateResaleItemResponse) => void;
}

export function useCreateResaleItem(options?: UseCreateResaleItemOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createResaleItem,
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: resaleItemsQueryKeys.lists() });
      options?.onSuccess?.(response);
    },
  });
}
